import { ComponentBlock } from '@types';

import { types } from 'core/types';

import { component } from './component';
import { DateInputProps, DateInputTriggers } from './index';

export const block: ComponentBlock<'dateInput', DateInputProps, DateInputTriggers> = {
  id: 'dateInput',
  render: component,
  props: {
    name: {
      type: types.string,
    },
    value: {
      type: types.string,
    },
    label: {
      type: types.string,
    },
    placeholder: {
      type: types.string,
    },
    size: {
      type: types.string,
    },
  },
  triggers: {
    onBlur: {
      name: 'On blur',
      description: 'When the control is unfocused',
    },
  },
};
